import KeywordRecord from 'records/keyword';
import { collectionReducer } from 'utils/reducerGenerator';

export const { reducer, types } = collectionReducer({
    namespace: 'KEYWORD',
    transformer: KeywordRecord,
});

export const STOP_TRACKING_KEYWORDS = Symbol('stop_tracking_keywords');
export const STOP_TRACKING_KEYWORDS_FAIL = Symbol('stop_tracking_keywords_fail');
export const STOP_TRACKING_KEYWORDS_SUCCESS = Symbol('stop_tracking_keywords_success');

export default reducer;
